import useFetchVersion from '@hooks/useFetchVersion';
import { createStorageKey, getLocalStorageItem, setLocalStorageItem } from '@utils/storage';
import { StorageKeys } from '@constants/storageKeys';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { showReleasesNotificationAtom } from '@js/store/viewSettingsAtoms';

const useReleasesNotification = () => {
    const [showNotification, setShowNotification] = useAtom(showReleasesNotificationAtom);
    const storageKey = createStorageKey([StorageKeys.ReleasesNotificationCounter]);
    const { data: version } = useFetchVersion();
    const apiCounter = version && version.releaseNotificationVersion ? version.releaseNotificationVersion : 0;
    const storedCounter = getLocalStorageItem<string>(storageKey);
    const localCounter = storedCounter ? +storedCounter : 0;

    useEffect(() => {
        if (!version || localCounter >= apiCounter) {
            return;
        }

        setShowNotification(true);
    }, [version, localCounter, apiCounter]);

    const markNotificationAsSeen = () => {
        setShowNotification(false);
        setLocalStorageItem(storageKey, apiCounter.toString());
    };

    return {
        localCounter,
        apiCounter,
        showNotification,
        markNotificationAsSeen,
    };
};

export default useReleasesNotification;
